import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function FlightInboundStrokeIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...size !== undefined && { width: size, height: size }}
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M22.1962 21.254C22.1962 20.8398 21.8516 20.504 21.4265 20.504H2.95278C2.52767 20.504 2.18304 20.8398 2.18304 21.254C2.18304 21.6682 2.52767 22.004 2.95278 22.004H21.4265C21.8516 22.004 22.1962 21.6682 22.1962 21.254Z"
				fill="currentColor"
			/>
			<path
				d="M15.0603 1.92828C14.9497 1.9247 14.839 1.94783 14.7386 1.9968L8.57546 5.00111L6.64025 4.48899L6.62328 4.48482L6.60542 4.48067C5.53551 4.25659 4.2577 4.44425 3.3698 4.93222L2.31984 5.49855L2.30486 5.50681L2.28989 5.51595C1.00721 6.2952 1.2494 8.17918 2.63902 8.63763L2.64886 8.64103L2.6596 8.64441L7.33736 10.0225L12.2452 16.0766C12.3371 16.1899 12.4636 16.2714 12.6048 16.3081L15.41 17.0361C15.6603 17.101 15.9257 17.0183 16.0958 16.8236C16.266 16.6289 16.3118 16.3546 16.2139 16.1154L14.3408 11.5363L18.4441 12.0736C18.6632 12.1023 18.8826 12.0228 19.033 11.861L22.4611 8.17466C22.6263 7.99676 22.6849 7.74447 22.6146 7.51209C22.5442 7.2795 22.3549 7.10164 22.1185 7.04536L19.6849 6.46594L19.6144 6.45289C19.4496 6.43158 19.2819 6.47141 19.1431 6.56571L17.8352 7.45478L14.4919 6.56941L17.341 3.42288C17.5062 3.24049 17.561 2.98342 17.4837 2.74981C17.4062 2.51616 17.2088 2.3417 16.9673 2.2941L15.1699 1.94068L15.0603 1.92828ZM4.02312 6.13106C4.60889 5.80739 5.54977 5.65795 6.31545 5.81532L17.7856 8.85569C17.977 8.90638 18.1807 8.87137 18.3444 8.76009L19.6619 7.86374L20.6631 8.10234L18.2731 10.6728L13.7873 10.0858L13.4868 9.45305L13.4164 9.33681C13.2299 9.08639 12.8899 8.98952 12.5935 9.12014C12.255 9.2695 12.0972 9.66155 12.2373 10.004L14.434 15.3703L13.1655 15.0418L8.26315 8.99753L8.19162 8.92222C8.11575 8.85328 8.02499 8.80207 7.92583 8.77277L3.06123 7.33814C2.77466 7.23891 2.72552 6.85739 2.99168 6.68818L4.01784 6.13471L4.02312 6.13106ZM15.5181 3.40079L13.0052 6.17524L10.5947 5.53673L15.1316 3.3245L15.5181 3.40079Z"
				fill="currentColor"
			/>
		</svg>
	);
}

FlightInboundStrokeIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default FlightInboundStrokeIcon;
